import React from "react";

import { cn } from "@/utils/cn";

interface SelectFieldProps {
  label?: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  error,
  required = false,
  children,
  className,
}) => {
  return (
    <div className={cn("form-select-field", className)}>
      {label && (
        <div
          className={cn(
            "form-select-field-label",
            error && "form-select-field-label-error",
          )}
        >
          {label}
          {required && <span className="form-select-field-required">*</span>}
        </div>
      )}
      <div className="form-select-field-wrapper">
        <div className="form-select-field-content">{children}</div>
        {error && <div className="form-select-field-error">{error}</div>}
      </div>
    </div>
  );
};

export default SelectField;
